const config = {
  projectInfoList: [
    {
      contribution_scale: 'CONTRIBUTION_SCALE', // 出资比例
      legal_person: 'LEGAL_PERSON', // 项目法人
      address: 'ADDRESS', // 项目地址
      project_scale: 'PROJECT_SCALE', // 项目规模
      relate_code: '', // 项目类别关联代码
      project_code: 'PROJECT_CODE', // 项目编号
      approval_name: 'APPROVAL_NAME', // 项目审批文件
      approval_authority: 'APPROVAL_AUTHORITY', // 项目审批单位
      project_name: 'PROJECT_NAME', // 项目名称
      invest_project_code: '', // 投资项目统一代码
      upload_create_time: '', // ****
      contactInformation: 'CONTACT_INFORMATION', // 联系方式
      approval_number: 'APPROVAL_NUMBER', // 项目审批文号
      last_update: '', // 
      fund_source: 'FUND_SOURCE', // 资金来源
      data_create_time: '', // 项目创建时间
      data_timestamp: '', // 数据时间戳
      upload_last_update_time: '', // 
      id: '', // 
      industries_type: '', // 项目行业分类
      class_ver_code: '', // 分类版本代码
      contactor: 'CONTACTOR', // 联系人
      region_code: '' // 项目所在行政区域代码
    }
  ],
  sectionInfoList: [
    {
      plan_file_relId: '', // 规划审批文件
      bid_section_content: '', // 标段包内容
      bid_ection_num: 'BID_SECTION_NUM', // 标段包招标次数
      tender_id: '', // 标段Id
      currency_code: '', // 标段合同估算价币种代码
      capital_file_relId: '', // 资金证明文件
      bid_qualification: 'ENTERPRISE_QUALIFICATIONS_REQUIRE', // 投标人资格条件
      upload_create_time: '', // ****
      last_update: '', // 最后更新时间
      data_create_time: '', // 创建时间
      tender_project_classify_code: '', // 标段分类代码
      id: '', // 
      bid_section_code: 'BID_SECTION_CODE', // 标段包编号
      contract_file_relId: '', // 招标代理机构合同文件
      tra_place_code: '', // 交易发生行政区域代码
      topic_file_relId: '', // 立项审批文件
      price_unit: '', // 标段合同估算价单位
      bid_tender_mode: 'BID_TENDER_MODE', // 标段包招标方式
      contract_reckon_price: '', // 标段合同估算价
      data_timestamp: '', // 数据时间戳
      upload_last_update_time: '', // 
      tender_project_code: '', // 招标项目编号
      check_file_relId: '', // 审图审批文件
      bid_section_name: 'BID_SECTION_NAME', // 标段包名称
      region_code: '' // 标段包所在行政区域代码
    }
  ],
  tenderProjectInfoList: [
    {
      tender_agency_code_type: '', // 招标代理机构类别
      owner_name: 'TENDERER_NAME', // 项目业主名称
      tender_project_type: '', // 招标项目类别
      project_code: 'PROJECT_CODE', // 项目编号
      tender_mode: 'TENDER_MODE', // 招标方式
      tender_project_name: 'TENDER_PROJECT_NAME', // 招标项目名称
      supervise_dept_name: 'SUPERVISE_DEPT_NAME', // 监督部门名称
      tenderer_code_type: '', // 招标人类别
      tender_agency_name: 'TENDER_AGENCY_NAME', // 招标代理机构名称
      tenderer_name: 'TENDERER_NAME', // 招标人名称
      tender_agency_code: 'TENDER_AGENCY_CODE', // 招标代理机构代码
      last_update: '', // 
      data_create_time: '', // 创建时间
      data_timestamp: '', // 数据时间戳
      upload_last_update_time: '', // 
      tender_project_code: 'TENDER_PROJECT_CODE', // 招标项目编号
      supervise_dept_code: 'SUPERVISE_DEPT_CODE', // 监督部门代码
      id: '', // 
      tender_content: '', // 招标内容与范围及招标方案说明
      tenderer_code: 'TENDERER_CODE', // 招标人代码
      bid_project_id: '', // 招标项目Id
      region_code: '', // 招标项目所在行政区域代码
      tender_organize_form: '' // 招标组织形式
    }
  ]
}

const setRegInfoToTheForm = (form, json) => {
  let keys = ['projectInfoList', 'sectionInfoList', 'tenderProjectInfoList']
  form.REGISTRATION = json
  keys.forEach(key => {
    let obj = config[key][0]
    for(let k in obj) {
      let v = obj[k]
      if(v) {
        form[v] = json[key][0][k]
      }
    }
  })
  form.REGION_CODE = json.projectInfoList[0].region_code
  // if(!/^\d{6}$/.test(form.regionId)) {
  // }
}

export default {setRegInfoToTheForm}